import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WizardBarNavComponent } from './wizard-bar-nav/wizard-bar-nav.component';
import { InlineSVGModule } from 'ng-inline-svg';
import { SharedModule } from '../shared/shared.module';



@NgModule({
  declarations: [WizardBarNavComponent],
  imports: [
    CommonModule,
    InlineSVGModule,
    SharedModule,
  ],
  exports: [
    WizardBarNavComponent,
  ]
})
export class WizardBarModule { }
